module.exports = __webpack_public_path__ + "static/media/team-member-01.d383d4cf.jpg";